var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandicap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd; fill: currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "handicap"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "cls-1",
    d: "M19,9v8.26a7.86,7.86,0,0,1,.89.73h0L25,19.21V28H23V20.79l-1.49-.35a7,7,0,1,1-9.88-3.57h0l-.71-1.65L13.31,9Zm-4,9a5.05,5.05,0,0,0-.68.07h0l1.6,3.74-1.84.78-1.65-3.86A5,5,0,1,0,15,18Zm2-7H14.69l-1.61,4.18.42,1A7.49,7.49,0,0,1,15,16a6.91,6.91,0,0,1,2,.29h0Zm.5-9A2.5,2.5,0,1,1,15,4.5,2.5,2.5,0,0,1,17.5,2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandicap);
export default __webpack_public_path__ + "static/media/handicap.4586974f.svg";
export { ForwardRef as ReactComponent };